<template>
    <div id="adminApp">
        <router-view/>
    </div>
</template>

<script>
    export default {
    }
</script>
  <style lang="scss">
  #adminApp .application {
    font-family: var(--font-family);
  }

  .theme--light.v-card, .v-card {
    background-color: var(--panel-background);
  }

  .theme--light.application {
    background-color: var(--background--color)!important
  }

  table.v-table tbody td {
    font-size: 11px!important;
    padding-left: 4px!important;
    padding-right: 4px!important;
    }

table.v-table thead th {
    padding-left: 4px!important;
    padding-right: 4px!important;
    }

.v-datatable__actions {
    flex-wrap: nowrap!important;
}

.v-datatable__actions__pagination {
    white-space: nowrap;
}
  </style>
